import Cookies from "js-cookie";
import { useMutation, useQueryClient } from "react-query";
import { serverBaseUrl } from "../config/envs";

const add = async (token = null, postData) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${serverBaseUrl}/create_standard_field`, {
    method: "POST",
    headers,
    body: JSON.stringify(postData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "Something went wrong");
  }

  return data;
};

export const useCreateNewField = () => {
  const token = Cookies.get("token");
  const queryClient = useQueryClient();

  return useMutation((postData) => add(token, postData), {
    onSuccess: () => {
      queryClient.invalidateQueries(["get_fields", token]);
    },
  });
};
